import React, { useState, useEffect } from "react";
import CustomStepper from "../../../../components/ui_comps/CustomStepper";
import { useSelector, useDispatch } from "react-redux";
import BasicDetails from "../../clients/client_onboard/BasicDetails";
import ClientFileUploads from "../../clients/client_onboard/ClientFileUploads";
import ClientBankDetails from "../../clients/client_onboard/ClientBankDetails";
import ClientReference from "./ResellerReference";
import { resellerModalNavigation } from "../../../../../data/redux/slice/modalNavigationSlice";
import { addResellerDataAction } from "../../../../../data/redux/slice/resellerDataSlice";
import ResellerBankDetails from "./ResellerBankDetails";

function ResellerOnboardIndex({ onClose, onSuccess, onClickBack }) {
  const [currentStep, setCurrentStep] = useState(1);
  const currentModalStep = useSelector(
    (state) => state.modalNavSlice?.resellerStep
  );
  const resellerData = useSelector((state) => state.onboardResellerReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    setCurrentStep(currentModalStep);
  }, [currentModalStep]);

  return (
    <div
      style={{
        // maxWidth: 550,
        // minWidth: 350,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CustomStepper totalStep={4} currentStep={currentStep} />

      <div
        style={{
          width: "100%",
          height: "100%",
          marginTop: 10,
          padding: "0px 15px",
        }}
      >
        {currentStep === 1 ? (
          <BasicDetails
            onClickBack={onClose}
            onClickNext={(data) => {
              setCurrentStep(2);
              dispatch(resellerModalNavigation(2));
              dispatch(
                addResellerDataAction({
                  ...data,
                })
              );
            }}
            reduxData={resellerData}
          />
        ) : currentStep === 2 ? (
          <ClientFileUploads
            onClickBack={onClose}
            onClickNext={(data) => {
              setCurrentStep(3);
              dispatch(resellerModalNavigation(3));
              dispatch(
                addResellerDataAction({
                  ...data,
                })
              );
            }}
          />
        ) : currentStep === 3 ? (
          <ResellerBankDetails
            onClickBack={onClose}
            onClickNext={(data) => {
              setCurrentStep(4);
              dispatch(resellerModalNavigation(4));
              dispatch(
                addResellerDataAction({
                  ...data,
                })
              );
            }}
            reduxData={resellerData}
          />
        ) : currentStep === 4 ? (
          <ClientReference
            onClickBack={onClose}
            onClickNext={() => {
              //   setCurrentStep(2);
            }}
            onSuccess={() => {
              onSuccess();
            }}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default ResellerOnboardIndex;
